import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IEquipmentDetails } from '@model/equipmentDetails';

import { apiClient } from '@services/apiClient';

import type { IAiHistory } from '../model/aiHistory';

interface IResponse {
  actionListHistory: Array<IAiHistory>;
  model: IEquipmentDetails;
}

export const hardwareOverviewEquipmentItemKey = (equipmentType?: string, itemId?: string) => [
  'hardwareOverviewEquipmentItem',
  equipmentType,
  itemId,
];
export const hardwareOverviewEquipmentItemFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL}${queryKey[1]}/${queryKey[2]}`);

const hardwareOverviewEquipmentItemSelect = ({ data }: AxiosResponse<IResponse>) => data;

export const useHardwareOverviewEquipmentItemQuery = ({
  equipmentType,
  itemId,
}: {
  equipmentType?: string;
  itemId?: string;
}) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: hardwareOverviewEquipmentItemKey(equipmentType, itemId),
    queryFn: hardwareOverviewEquipmentItemFn,
    enabled: !!(equipmentType && itemId),
    select: hardwareOverviewEquipmentItemSelect,
  });
};
